<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <BasicRedirection
    :show-if="!!salariéEnCours"
    @after-scroll="définirSalariéEnCours(null)"
  >
    <template #topAnchor>
      <ListeSalaries />
    </template>
    <template #bottomAnchor>
      <SaisieSalarie />
    </template>
  </BasicRedirection>
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import ListeSalaries from './sections/liste/ListeSalariesSection.vue'
  import SaisieSalarie from './sections/saisie/SaisieSalarie.vue'
  import { AF_SALARIES_ACTIONS } from './useSalarieActions'

  const { définirSalariéEnCours, salariéEnCours } = inject(AF_SALARIES_ACTIONS)!
</script>
